import React from "react";
import ProcessingFeeDateRangeReportPage from "./ProcessingFeeDateRangeReportPage";

export default function ProcessingFeeTransactions() {
  return <ProcessingFeeDateRangeReportPage i18nKey="processing_fee_transactions" />;
}
